export default __webpack_public_path__ + "static/media/_MG_7920.68ee1aad.jpg";